<template>
  <div>
    <div class="card_wraper first_entry_wrap">
      <div class="first_entry_title">
        <span class="title">请先绑定设备</span>
        <a @click="returnBtnHandle"
           class="first_entry_go_login">
          返回登录
        </a>
      </div>
      <div class="info_wrap"></div>

      <div class="first_entry_btn">帮设备去联网（暂不支持）</div>

      <div class="first_entry_btn"
           @click="bindDeviceBtnHandle">
        已联网，去绑定
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  computed: {},
  methods: {
    bindDeviceBtnHandle () {
      this.$router.push('/DeviceManageMain/hostManage')
    },
    returnBtnHandle () {
      ////退出登录按钮
      sessionStorage.clear() //清空浏览器缓存token
      this.$store.dispatch('asyUpdataToken', '') ///清空vuex里面的token

      this.$router.replace('/login')
    }
  },
  beforeCreate () {
    //代号 20231229-1
    if (this.$store.state.configinfo.bindHostState == '1') {
      // 说明已经绑定上了主机
      //说明这是用户第一次绑定过主机返回的  而且是主机已经绑定成功  所以需要则返回的首页
      this.$router.replace('/controlpage');  //  返回到区域控制页面

    }
  },
  mounted () {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
  }
}
</script>

<style>
.first_entry_wrap {
  width: 400px;
  padding: 30px 60px 30px 40px;
}
.first_entry_title {
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
  text-align: center;
  position: relative;
}
.first_entry_go_login {
  position: absolute;
  right: 0;
}

.first_entry_btn {
  height: 54px;
  line-height: 54px;
  background: var(--primary-color);
  font-size: 16px;
  color: #fff;
  text-align: center;
  /* border:1px solid black; */
  margin-top: 50px;
  border-radius: 4px;
  cursor: pointer; /*移入时光标样式*/
}
.first_entry_btn:active {
  /* background-color: hotpink; */
  opacity: 0.8;
}
</style>
